import { linkTypeToIcon } from '@/helpers/transforms'
import type { FC } from 'react'
import type { LinkType } from '../../frontend-types'
import { LinkIcon } from '../atoms/LinkIcon'
import { TextAreaContent } from '../atoms/TextAreaContent'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type TextCTABlockProps = {
	heading: string
	link: LinkType
}

export const TextCTABlock: FC<TextCTABlockProps> = ({ heading, link }) => {
	return (
		<ContentBlockWrapper blockTypes={['component', 'cta']}>
			<div className="col-span-full flex flex-col gap-y-sm">
				<TextAreaContent
					className="font-semibold text-blue-shade-70"
					textSize="text-body-md"
					text={heading}
				/>
				<LinkIcon {...link} icon={linkTypeToIcon(link)} intent="primary" />
			</div>
		</ContentBlockWrapper>
	)
}

export default TextCTABlock
